import React from 'react'
import Sidebar from '../Sidebar/Sidebar';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LossPreventionForm from './LossPreventionForm';

import { useNavigate } from "react-router-dom";
const ReportForm = () => {

  const user = sessionStorage.getItem("first_name");

  const [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();
  return (
    <Sidebar>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-white/60 z-[9999]">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-red-500 border-t-transparent"></div>
        </div>
      )}

      <div className="p-6 max-w-4xl mx-auto min-w-2/3 max-w-full">
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
          <h2 className="text-xl font-bold mb-4 text-[#EF7320]">Report Form</h2>
          <div>
            <p className='mb-4 border-b-2 border-gray-200 pb-2'> Hi {user}</p>


            <div className='mt-4 mb-4 pb-3 border-b-2 border-gray-200 pb-2'>


              <p>
                This Loss Prevention and Risk Management Reporting Tool should be used for reporting ALL incidents in our restaurants. For critical incidents, immediately notify your Area Coach.
              </p>

              <p className='mt-3'> if you are reporting an employee injury, please use the Employee Injury Report Form.</p>
            </div>



            <p className=''> The following incidents are considered <span className='font-bold'>CRITICAL:</span></p>
            <ul className="list-disc pl-5 mt-2 mb-4 font-bold mb-4 pb-3 border-b-2 border-gray-200 pb-2">
              <li>Employee death</li>
              <li>Employee hospitalization</li>
              <li>Employee amputation</li>
              <li>Employee loss of an eye</li>
              <li>Employee loss of a limb</li>
              <li>Employee loss of a body part</li>

            </ul>


            <p className='mb-4'>If you are reporting a critical incident, please contact your supervisor immediately.</p>


            <p className='font-bold mb-3 mt-3'>Thank you for reporting this incident timely through the web reporting tool!</p>

          </div>


          <div className="flex flex-row">
            <button
              className="bg-[#EF7320] text-white px-4 py-2 rounded-lg mr-4 w-1/2 flex items-center justify-center font-bold"
              onClick={() => navigate("/claimreport")}
            >
              <ReceiptIcon fontSize="large" className="me-2" />
              Report Claim
            </button>

            <button
              className="bg-[#EF7320] text-white px-4 py-2 rounded-lg w-1/2 flex items-center justify-center font-bold"
              onClick={() => navigate("/report")} // Example route
            >
              <ReceiptLongIcon fontSize="large" className="me-2" />
              View Claim History
            </button>
          </div>

        </div>




      </div>





    </Sidebar>
  )
}

export default ReportForm